import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";


import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
    }

    getData() {
        const { nombre, obligatorio } = this.state;
        return {
            "nombre": nombre,
            "obligatorio": obligatorio
        }
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.proyectos.config.plan.campos.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                onPreSubmit={() => this.getData()}
                successMessage={"El Campo del Plan de Trabajo ha sido creado con éxito."}
                title={"Nuevo Campo del Plan de Trabajo"}
                buttonTitle={"Nuevo Campo del Plan de Trabajo"}
                buttonIcon={"fa fa-plus fa-lg"}

                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}>
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input onChange={(e) => this.setState({ nombre: e.target.value })} type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>
                            Obligatorio
                            <input className="ml-2" onChange={(e) => this.setState({ obligatorio: (e.target.value == "on" ? true : false) })} type="checkbox" name="obligatorio" />
                        </Label>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_Campos/Create.js